import HomePage from "../components/LandingPage/LandingPage"

export const LandingPage=()=>{
    return <HomePage/>
}